<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let event;
  let date = new Date(event.start_date);

  function editEvent() {
    dispatch("editEvent", event);
  }
</script>

<li class="event" on:dblclick={editEvent}>
  <span class="name">{event.name}</span>
  <span class="date">{date.getHours()}:{date.getMinutes()}</span>
</li>

<style type="text/scss">
  .event {
    border: 1px solid transparent;
    margin-bottom: 5px;
    padding: 5px;
    border-radius: 5px;
    background-image: linear-gradient(to right, #ed1c24, #fff);
    background-origin: border-box;
    line-height: 1.2;
    opacity: 0.6;
    transition: all 200ms;

    &:last-of-type {
      margin-bottom: 0;
    }

    &:hover {
      opacity: 1;
    }

    .name {
      font-weight: bold;
      color: white;
    }

    .date {
      margin-top: 5px;
      display: inline-block;
      text-align: right;
      width: 100%;
      font-size: 0.75em;
    }
  }
</style>
